/**
 * Enum доступных переводов
 */
export enum LangEnum {
  /**
   * русский
   */
  RU = 'ru',
  /**
   * английский
   */
  EN = 'en',
}
